import type { CustomerWorkbenchColumnKey, CustomerWorkbenchListParams } from "../types";

export const crmCustomerWorkbenchQueryRootKey = ["crm_customer_workbench"] as const;

export const crmCustomerWorkbenchDefaultListParams: CustomerWorkbenchListParams = {
  viewScope: "mine",
  page: 1,
  pageSize: 20,
  isDisabled: false,
  sortField: "contact_count",
  sortDirection: "desc",
};

export const CRM_CUSTOMER_WORKBENCH_VISIBLE_COLUMNS_STORAGE_KEY =
  "crm.customer_workbench.visible_columns.v1";

export const crmCustomerWorkbenchColumnOptions: Array<{
  key: CustomerWorkbenchColumnKey;
  label: string;
  required?: boolean;
  pinnedEnd?: boolean;
}> = [
  { key: "province", label: "省/市" },
  { key: "orgUnit", label: "组织单元/校" },
  { key: "customerName", label: "客户名称", required: true },
  { key: "owners", label: "所属销售" },
  { key: "contacts", label: "联系人" },
  { key: "opportunities", label: "商机" },
  { key: "createdAt", label: "创建时间" },
  { key: "actions", label: "操作", required: true, pinnedEnd: true },
];

export const crmCustomerWorkbenchDefaultVisibleColumns: CustomerWorkbenchColumnKey[] =
  crmCustomerWorkbenchColumnOptions.map((item) => item.key);
